'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var useGoogleMaps = require('./useGoogleMaps.js');
var parseGeocoderResults = require('./utils/parseGeocoderResults.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var globalGeocoderServer = {
  current: null
};
function useGeocoder() {
  var {
    status,
    google
  } = useGoogleMaps.useGoogleMaps();
  React__namespace.useEffect(() => {
    if (!globalGeocoderServer.current && status === 'ready') {
      globalGeocoderServer.current = new google.maps.Geocoder();
    }
  }, [status, google]);
  var geocode = React__namespace.useCallback((request, componentsMap) => {
    return new Promise((resolve, reject) => {
      var _globalGeocoderServer;

      (_globalGeocoderServer = globalGeocoderServer.current) === null || _globalGeocoderServer === void 0 ? void 0 : _globalGeocoderServer.geocode(request, (results, status) => {
        if (status === 'OK') {
          return resolve(parseGeocoderResults.parseGeocoderResults(results, componentsMap));
        }

        return reject(status);
      });
    });
  }, []);
  return {
    status,
    geocode
  };
}

exports.useGeocoder = useGeocoder;
